module.exports = __webpack_public_path__ + "static/media/retos_card_detail.ee24a621.png";